import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'elm-tabs-content-loader',
  template: `
    <elm-content-loader
      [width]="100"
      [height]="rows * (rowHeight + 10)"
      preserveAspectRatio="none"
      [responsive]="true"
    >
      <ng-container *ngFor="let row of size; let i = index">
        <svg:rect
          x="0"
          [attr.y]="i * rowHeight + i * 10"
          rx="0"
          ry="0"
          width="100"
          [attr.height]="rowHeight"
        />
      </ng-container>
    </elm-content-loader>
  `,
  host: { class: 'elm-block' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsContentLoaderComponent {
  rows = 6;

  rowHeight = 75;

  get size() {
    return new Array(this.rows);
  }
}
